const LOCAL_ID_PREFIX = 'm';
const LOCAL_ID_PATTERN = /^m[0-9a-z]{14}$/;
const CHAT_TYPES = new Set(['PRIVATE', 'GROUP', 'SYSTEM']);
const FNV_OFFSET_BASIS = 0x811c9dc5;
const FNV_PRIME = 0x01000193;

function fnv1a32(value) {
	const text = String(value ?? '');
	let hash = FNV_OFFSET_BASIS >>> 0;
	for (let index = 0; index < text.length; index += 1) {
		hash ^= text.charCodeAt(index);
		hash = Math.imul(hash, FNV_PRIME) >>> 0;
	}
	return hash >>> 0;
}

function hashFragment(value) {
	return fnv1a32(value).toString(36).padStart(7, '0');
}

function normalizeIdentity(value) {
	if (value === undefined || value === null) {
		return '';
	}
	return String(value).trim();
}

function resolveConversationKey(chatInfo) {
	const chatType = normalizeIdentity(chatInfo && chatInfo.type).toUpperCase();
	const targetId = normalizeIdentity(chatInfo && chatInfo.targetId);
	if (!CHAT_TYPES.has(chatType) || !targetId) {
		throw new Error('生成 localId 失败：会话标识无效');
	}
	return `${chatType}:${targetId}`;
}

function buildStableLocalIdSource(message, chatInfo) {
	const convKey = resolveConversationKey(chatInfo);
	const tmpId = normalizeIdentity(message.tmpId);
	if (tmpId) {
		return `tmp|${convKey}|${tmpId}`;
	}
	const id = normalizeIdentity(message.id);
	if (id) {
		return `id|${convKey}|${id}`;
	}
	const seqNo = normalizeIdentity(message.seqNo);
	if (seqNo) {
		return `seq|${convKey}|${seqNo}`;
	}
	throw new Error('生成 localId 失败：消息标识无效');
}

export function ensureStableMessageLocalId(message, chatInfo) {
	if (!message || typeof message !== 'object') {
		throw new TypeError('生成 localId 失败：消息对象无效');
	}
	const currentLocalId = message.localId === undefined || message.localId === null ? '' : String(message.localId);
	if (LOCAL_ID_PATTERN.test(currentLocalId)) {
		message.localId = currentLocalId;
		return currentLocalId;
	}
	const source = buildStableLocalIdSource(message, chatInfo);
	const localId = `${LOCAL_ID_PREFIX}${hashFragment(source)}${hashFragment(`${source}|1`)}`;
	message.localId = localId;
	return localId;
}
